import { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import Card from "./Card";
import { COLORS } from "../../../dashboard/epis-dashboard/configs/config";

export default function GraficoRetiradas({ total, data = [], ultima, loading }) {
    const fmt = (n) => (n ?? 0).toLocaleString("pt-BR");

    const { labels, valores } = useMemo(
        () => ({
            labels: data.map((d) => d.label),
            valores: data.map((d) => d.quantidade),
        }),
        [data]
    );

    if (!total || total <= 0) {
        return (
            <Card title="Gráfico de Retiradas" loading={loading}>
                <Typography display="flex" justifyContent="center">
                    Nenhum dado encontrado
                </Typography>
            </Card>
        );
    }

    return (
        <Card
            title="Gráfico de Retiradas"
            subtitle={`Total de retiradas: ${fmt(total)}`}
            loading={loading}
        >
            <Box>
                <BarChart
                    height={300}
                    xAxis={[{ scaleType: "band", data: labels }]}
                    series={[
                        {
                            data: valores,
                            label: "Retiradas",
                            valueFormatter: (v) => fmt(v),
                            color: COLORS.g1,
                            
                        },
                    ]}
                    barLabel="value"
                    margin={{ top: 20, right: 10, bottom: 30, left: 50 }}
                    slotProps={{ legend: { hidden: true } }}
                />

                <Typography variant="caption" color="text.secondary" display="block" mt={1}>
                    Última retirada: {ultima || "N/A"}
                </Typography>
            </Box>
        </Card>
    );
}